<template>
  <!-- Photos -->
  <div
    class="-mx-12 p-12 flex flex-col flex-wrap justify-between border-t border-purple-ap-t03"
  >
    <div>
      <h2 class="font-semibold text-purple-ap-100">
        Additional Photos
      </h2>
    </div>
    <div class="mt-5">
      <VueGallery
        :images="this.additionalPhotos"
        :index="index"
        @close="index = null"
      ></VueGallery>
      <div
        class="image"
        v-for="(image, imageIndex) in this.additionalPhotos"
        :key="imageIndex"
        @click="index = imageIndex"
        :style="{
          backgroundImage: 'url(' + image + ')',
          width: '150px',
          height: '150px',
          margin: 'auto',
        }"
      ></div>
    </div>
  </div>
</template>

<script>
import VueGallery from "vue-gallery";

export default {
  name: "PhotoGallery",
  props: ["photos"],
  components: {
    VueGallery,
  },
  data() {
    return {
      images: this.photos,
      index: null,
    };
  },
  computed: {
    additionalPhotos() {
      let photos = [];
      this.photos.map((p) => {
        photos.push(`https://ap2.chinet.org/api/v1.0${p}/sm`);
      });
      photos.splice(0, 1);
      return photos;
    },
  },
};
</script>

<style scoped>
.blueimp-gallery {
  background: rgba(0, 0, 0, 0.8);
}

.image {
  margin: auto;
  float: left;
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center center;
  border: 1px solid #ebebeb;
  margin: 5px;
}
</style>
